/**
 * @param {string} selector - CSS selector to target elements
 */
function getLatestTimeStamp(selector = 'div[data-md-render-date]') {
    let timeStamps = [];
    let timeStampElementArray = [].slice.call(document.querySelectorAll(selector));

    if (!timeStampElementArray.length) {
        return;
    }

    timeStampElementArray.forEach(
        function(currentValue) {
            timeStamps.push(currentValue.getAttribute('data-md-render-date'));
        }
    );

    if (timeStamps.length > 0) {
        return timeStamps.reduce(function(a, b) {
            return Math.max(a, b);
        });
    } else {
        return undefined;
    }
}

/**
 * @param {string} timestamp - single timestamp
 * @param {string} target - output destination
 */
function printFormattedTimeStamp(timestamp, target = 'nw-c-md-last-updated') {
    if (timestamp === undefined) {
        return;
    }

    const date = new Date(timestamp);
    const hours = date.getHours();
    const minutes = ((date.getMinutes() < 10) ? '0' : '') + date.getMinutes();
    const day = date.getDate();
    const months_arr = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    const month = months_arr[date.getMonth()];
    const year = date.getFullYear();

    const docFrag = document.createDocumentFragment();
    const element = document.createElement('p');
    element.className = 'nw-c-md-last-updated__text gs-u-mt-alt+ gs-u-mt0@m gs-u-mb-';
    element.innerHTML = `As of <time>${hours}:${minutes}</time> ${day} ${month} ${year}`;
    docFrag.appendChild(element);

    const targetElement = document.getElementsByClassName(target)[0];
    const targetFirstChild = document.getElementsByClassName(target)[0].firstElementChild;
    targetElement.insertBefore(docFrag, targetFirstChild);
}

// write latest update string to page
printFormattedTimeStamp(getLatestTimeStamp());


// WEBPACK FOOTER //
// ./js/component.js